import { action, makeAutoObservable } from 'mobx';
import AppStore from 'Stores/AppStore';
import FiltersStore from 'Stores/Metrics/FiltersStore';
import MetricsRequests from 'Utils/Requests/MetricsRequests';

class UsersMetricsStore {
    usersLoading;
    exportLoading;
    /** @type {number[]} */
    selectedMetricUsersIds = [];
    searchString;
    lastUsersHasActive;

    constructor() {
        makeAutoObservable(this);
        this.ClearStore();
    }

    ClearStore() {
        this.usersLoading = true;
        this.exportLoading = false;
        this.usersOnPage = {};
        this.selectedMetricUsersIds = [];
        this.lastUsersCount = 0;
        this.lastUsersOnPageIds = [];
        this.searchString = "";
        this.lastUsersHasActive = false;
    }

    UpdateUsersFromTimer() {
        this.UpdateUsers(this.pageToSet, true);
    }

    GetUsers(pageToSet) {
        this.UpdateUsers(pageToSet, false);
    }

    UpdateUsers = action((pageToSet, isUpdateFromTimer) => {
        if (this.tableStore == null)
            return;

        if (pageToSet)
            this.pageToSet = pageToSet;
        if (!this.pageToSet)
            this.pageToSet = 1;

        let { elementsPerPage } = this.tableStore.paginationInfo;
        let start = (this.pageToSet - 1) * elementsPerPage;

        if (Object.keys(this.usersOnPage).length == 0 && isUpdateFromTimer == false) {
            this.usersLoading = true;
        }
        var skipError = isUpdateFromTimer;
        MetricsRequests.GetMetricUsers(
            start,
            elementsPerPage,
            this.searchString,
            skipError
        )
            .then(action((values) => {
                if (this.tableStore == null)
                    return;

                this.HandleDataUpdateUsersStore(values.rowsDataForPageOrAll);

                if (isUpdateFromTimer != true || this.lastUsersCount != values.countTotal) {
                    if (!this.tableStore.HandlePagination(this.SetPageData, values.countTotal, this.pageToSet, page => this.GetUsers(page))) {
                        return;
                    }
                    this.HandleDataUpdateTable();
                }

                if (this.usersLoading == true) {
                    this.usersLoading = false;
                }

                this.lastUsersCount = values.countTotal;
                this.lastUsersOnPageIds = Object.keys(this.usersOnPage);
                this.lastUsersHasActive = values.hasActive;
            }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, `Аналитика. Страница ${pageToSet}.`, `${window.SmrLocation}/usersMetrics?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'usersMetrics',
            params: {
                page: `${pageToSet}`
            }
        });
    }

    /** @param {WebMetricUser[]} data  */
    HandleDataUpdateUsersStore(data) {
        let us = {};
        let sortIndex = 0;

        data.forEach(metricUserDLFromServer => {
            us[metricUserDLFromServer.id] = metricUserDLFromServer;
            us[metricUserDLFromServer.id].sortIndex = sortIndex;
            sortIndex++;
        });

        this.usersOnPage = us;
    }

    HandleDataUpdateTable() {
        let sortable = Object.values(this.usersOnPage).map(it => it);
        sortable.sort((a, b) => a.sortIndex - b.sortIndex);
        this.tableStore.data = sortable;
    }

    /**
     * @param {boolean} isAllUsers
     */
    ExportUsersData(isAllUsers) {
        let selectedMetricUsersIds = isAllUsers ? null : this.selectedMetricUsersIds;
        MetricsRequests.ExportUsersData(FiltersStore.filters, selectedMetricUsersIds);
    }
}

export default new UsersMetricsStore();